const Types = {
  NEXT_STEP: "NEXT_STEP",
  PLAN_TYPE: "PLAN_TYPE",
  TOGGLE_SHOW_POP_UP: "TOGGLE_SHOW_POP_UP",
  TOGGLE_ACTIVE_POP_UP: "TOGGLE_ACTIVE_POP_UP",
};

export const state = {
  breadcrumb: {
    steps: Array.from(
      Array(+process.env.VUE_APP_BREADCRUMB_STEPS || 5),
      (x, i) => i + 1
    ),
    currentStep: 1,
    planType: "default",
  },
  popup: {
    isShowing: false,
    wasActivated: false,
  },
};

export const getters = {
  steps: state => state.breadcrumb.steps,
  currentStep: state => state.breadcrumb.currentStep,
  planType: state => state.breadcrumb.planType,
  getActivatedPopup: state => state.popup.wasActivated,
  getShowingPopup: state => state.popup.isShowing,
};

export const mutations = {
  [Types.NEXT_STEP]: (state, newStep) =>
    (state.breadcrumb.currentStep = newStep),
  [Types.PLAN_TYPE]: (state, planType) =>
    (state.breadcrumb.planType = planType),
  [Types.TOGGLE_SHOW_POP_UP]: (state, status) => {
    state.popup.isShowing = status;
  },
  [Types.TOGGLE_ACTIVE_POP_UP]: (state, status) => {
    state.popup.wasActivated = status;
  },
};

export const actions = {
  setNewStep: ({ commit }, newStep) => commit(Types.NEXT_STEP, newStep),
  setPlanType: ({ commit }, planType) => commit(Types.PLAN_TYPE, planType),
  toogleShowPopup: ({ commit }, status) =>
    commit(Types.TOGGLE_SHOW_POP_UP, status),
  toogleActivatedPopup: ({ commit }, status) =>
    commit(Types.TOGGLE_ACTIVE_POP_UP, status),
};
